const Birthday = "2003-09-30";

export default Birthday;
